import { useGoogleMap } from '@react-google-maps/api';
import React, { useEffect } from 'react';
import { useMapContext } from '../context/mapContext';
import useWindowSize from '../hooks/useWindowSize';

export const PanTo = () => {
  const map = useGoogleMap();
  const { panCoords } = useMapContext();
  const { width } = useWindowSize();

  useEffect(() => {
    if (map && panCoords) {
      if (width >= 1024) {
        map.panTo(panCoords);
        map.setZoom(14);
      } else {
        map.panTo(panCoords);
        map.setZoom(13);
        map.panBy(0, 70);
      }
    }
  }, [panCoords, map]);
  return null;
};
